<template>
  <div class="box">
    <sidebar
      style="width: 19%"
      :sidList="sidList"
      @sibIndex="getSibItem"
    ></sidebar>
    <div class="content">
      <currentLocation :sibItem="sibItem"></currentLocation>
      <div>
        <div v-if="sibItem.index == 0" class="teamList">
          <div
            v-for="(item, index) in teamList"
            :key="index"
            @click="teamChange(index)"
            :class="teamIndex == index ? 'teamActive' : ''"
          >
            {{ item.title }}
          </div>
        </div>

        <div v-if="sibItem.index == 3" class="gainList">
          <div
            v-for="(item, index) in gainList"
            :key="index"
            @click="gainChange(index)"
            :class="gainIndex == index ? 'gainActive' : ''"
          >
            {{ item.title }}
          </div>
        </div>

        <articleDetails
          v-if="
            (sibItem.index == 0 && teamIndex == -1) ||
            (sibItem.index == 1 && teamIndex == -1) ||
            (sibItem.index == 3 && gainIndex == -1)
          "
          :articleInfo="articleInfo"
        ></articleDetails>

        <div
          v-if="
            (sibItem.index == 0 && (teamIndex != -1 || teamIndex == 0)) ||
            sibItem.index == 2 ||
            (sibItem.index == 3 && (gainIndex == 2 || gainIndex == 3))
          "
        >
          <articleList
            :currentPage="currentPage"
            :page-size="pageSize"
            :articleList="articleList"
            :total="total"
            v-on:func="getOutstandingPersonnel"
            :type="type"
            :key="timer"
            v-on:personnelDetails="personnelDetails"
            v-if="isShowDetail == 0"
          ></articleList>

          <articleDetails
            v-if="isShowDetail == 1"
            :articleInfo="articleInfo"
            type="1"
          ></articleDetails>
        </div>

        <div
          v-if="sibItem.index == 3 && (gainIndex == 0 || gainIndex == 1)"
          class="frameBox"
        >
          <iframe
            :src="file_url"
            type="application/x-google-chrome-pdf"
            target="_blank"
            width="780"
            height="615"
            :key="timer"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2022-04-02 14:38
 */
import sidebar from "@/components/sidebar.vue"; // 侧边栏
import currentLocation from "@/components/currentLocation.vue"; // 当前位置
import articleList from "@/views/articleList.vue"; // 文章列表
import articleDetails from "@/views/articleDetails.vue"; // 文章详情
export default {
  components: { sidebar, currentLocation, articleDetails, articleList },

  data() {
    return {
      sidList: [
        {
          title: "研究方向",
          index: 0,
        },
        {
          title: "研究队伍",
          index: 1,
        },
        {
          title: "科研项目",
          index: 2,
        },
        {
          title: "科研成果",
          index: 3,
        },
      ],
      sibItem: {
        title: "研究方向",
        index: 0,
      },
      articleInfo: {},
      teamList: [
        { title: "杰出人员", index: 0 },
        { title: "研究人员", index: 1 },
        { title: "兼职人员", index: 2 },
        { title: "支撑人员", index: 3 },
        { title: "博士后", index: 4 },
      ],
      teamIndex: -1,

      currentPage: 1, // 分页第几页
      pageSize: 20,
      total: 0,
      articleList: [],

      type: "",

      gainList: [
        { title: "论文", index: 0 },
        { title: "专利", index: 1 },
        { title: "奖励", index: 2 },
        { title: "转化应用", index: 3 },
      ],
      gainIndex: -1,

      file_url: "", // pdf路径

      timer: new Date().getTime(),

      isShowDetail: 0,
    };
  },
  mounted() {
    this.getScienceInfo(1);
  },
  methods: {
    // 侧边栏传参
    getSibItem(item) {
      this.sibItem = item;
      this.isShowDetail = 0;
      if (item.index == 0) {
        this.getScienceInfo(1);
        this.teamIndex = -1;
        this.gainIndex = -1;
        this.articleList = [];
      }

      if (item.index == 1) {
        this.getScienceInfo(2);
        this.teamIndex = -1;
        this.gainIndex = -1;
        this.articleList = [];
      }

      if (item.index == 2) {
        this.getResearchProject(1);
        this.teamIndex = -1;
        this.gainIndex = -1;
        this.articleList = [];
        this.type = "1";
      }

      if (item.index == 3) {
        this.getScienceInfo(3);
        this.teamIndex = -1;
        this.gainIndex = -1;
        this.articleList = [];
      }
    },

    // 研究方向头部切换
    teamChange(index) {
      this.timer = new Date().getTime();
      this.teamIndex = index;
      this.getOutstandingPersonnel(1);
      if (index == 0) {
        this.type = "2";
        this.pageSize = 8;
      } else {
        this.type = "3";
        this.pageSize = 20;
      }
    },

    // 1研究方向 2研究队伍 3科研成果
    getScienceInfo(type) {
      let that = this;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Science/getScienceInfo`,
        data: {
          type: type,
        },
      }).then((result) => {
        // console.log("文章详情", result.data);
        if (result.data.code == 1) {
          that.articleInfo = result.data.data;
        }
      });
    },

    // 杰出人员/研究人员/兼职人员/支撑人员/博士后
    getOutstandingPersonnel(page) {
      let that = this;
      let url, data;
      if (this.teamIndex == 0) {
        url = `${this.$root.baseUrl}/Science/getOutstandingPersonnel`;
        data = {
          page: page,
        };
      } else {
        url = `${this.$root.baseUrl}/Science/getResearchTeam`;
        data = {
          type: this.teamIndex,
        };
      }
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: url,
        data: data,
      }).then((result) => {
        // console.log("文章详情", result.data);
        if (result.data.code == 1) {
          that.articleList = result.data.data.list;
          that.total = result.data.data.total_count;
        }
      });
    },

    // 杰出人员/研究人员/兼职人员/支撑人员/博士后跳转详情
    personnelDetails(item) {
      let that = this;
      this.teamIndex = -1;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Science/getPersonnelInfo`,
        data: {
          personnel_id: item.personnel_id,
        },
      }).then((result) => {
        // console.log("文章详情", result.data);
        if (result.data.code == 1) {
          that.articleInfo = result.data.data;
        }
      });
    },

    // 科研项目头部切换
    gainChange(index) {
      this.timer = new Date().getTime();
      this.gainIndex = index;
      this.type = "1";
      this.isShowDetail = 0;
      this.getPapersAndPatents();
    },

    // 科研项目
    getResearchProject(page) {
      let that = this;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Science/getResearchProject`,
        data: {
          page: page,
        },
      }).then((result) => {
        // console.log("文章详情", result.data);
        if (result.data.code == 1) {
          that.articleList = result.data.data.list;
          that.total = result.data.data.total_count;
        }
      });
    },

    // 论文与专利/奖励与转化应用/兼职人员/支撑人员/博士后
    getPapersAndPatents(page) {
      let that = this;
      let url, data;
      if (this.gainIndex == 0) {
        url = `${this.$root.baseUrl}/Science/getPapersAndPatents`;
        data = {
          type: 1, // 1论文
        };
      }
      if (this.gainIndex == 1) {
        url = `${this.$root.baseUrl}/Science/getPapersAndPatents`;
        data = {
          type: 2, // 2专利
        };
      }
      if (this.gainIndex == 2) {
        url = `${this.$root.baseUrl}/Science/getRewardAndApplication`;
        data = {
          type: 1, // 1奖励
        };
      }
      if (this.gainIndex == 3) {
        url = `${this.$root.baseUrl}/Science/getRewardAndApplication`;
        data = {
          type: 2, // 2转化应用
        };
      }
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: url,
        data: data,
      }).then((result) => {
        // console.log("文章详情", result.data);
        if (result.data.code == 1) {
          if (this.gainIndex == 0 || this.gainIndex == 1) {
            that.file_url = result.data.data[0].file_url;
          }
          if (this.gainIndex == 2 || this.gainIndex == 3) {
            that.articleList = result.data.data.list;
            that.total = result.data.data.total_count;
          }
        }
      });
    },

    // 学术委员会跳转详情
    articleDetails(item) {
      let that = this;
      this.isShowDetail = 1;
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrl}/Common/getArticleInfo`,
        data: {
          article_id: item.article_id,
        },
      }).then((result) => {
        console.log("文章详情", result.data);
        if (result.data.code == 1) {
          that.articleInfo = result.data.data;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
}

.content {
  width: 80%;
  padding: 0 32px 0 29px;
}

.teamList {
  display: flex;
  align-items: center;
  padding-top: 10px;
  > div {
    padding: 13px 17px 11px;
    background: #f2f2f2;
    font-size: 16px;
    font-weight: 400;
    color: #222222;
    margin-right: 20px;
    cursor: pointer;
  }
  .teamActive {
    background: #dcf3ff !important;
    color: #08599b !important;
    font-weight: bold !important;
  }
}

.gainList {
  display: flex;
  align-items: center;
  padding-top: 10px;
  > div {
    padding: 13px 0 11px;
    width: 20%;
    text-align: center;
    background: #f2f2f2;
    font-size: 16px;
    font-weight: 400;
    color: #222222;
    margin-right: 20px;
    cursor: pointer;
  }
  .gainActive {
    background: linear-gradient(90deg, #08599b 0%, #0a98e2 100%) !important;
    color: #ffffff !important;
    font-weight: 400 !important;
  }
}

.frameBox {
  width: 100%;
  padding: 30px 0;
}
</style>